module.exports = __webpack_public_path__ + "img/output_6.e55661a6.png";